import baseProperty from "./component-library249.mjs";
import basePropertyDeep from "./component-library310.mjs";
import isKey from "./component-library307.mjs";
import toKey from "./component-library309.mjs";
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
export {
  property as default
};
